<template>
    <el-dialog
		:title="$t('SetUp.RandomSettings')"
		:visible.sync="randomSetShow" 
		:close-on-click-modal="false"
    >
        <div class="el-dialog__body_div">
            <el-radio-group class="radio-group" v-model="randomType" @input="randomTypeInput">
                <el-radio :label="1">{{$t('SetUp.DoNotSet')}}</el-radio>
                <el-radio :label="2">{{$t('SetUp.RandomizeByQuestion')}}</el-radio>
                <el-radio :label="3">{{$t('SetUp.RandomByPage')}}</el-radio>
                <el-radio :label="4">{{$t('SetUp.PiecewiseRandom')}}</el-radio>
            </el-radio-group>
            <div class="quesList-box" v-if="randomType == 2">
                
                <el-button 
                    icon="el-icon-circle-plus-outline" 
                    size="small" 
                    v-if="quesList.length == 0" 
                    @click="addQuesList()"
                >{{$t('SetUp.NewlyAdded')}}</el-button>
                <div class="item" v-for="(item, index) in quesList" :key="index">
                    <span class="text">{{$t('SetUp.StartingQuestion')}}</span>
                    <PopoverNum
                        :value="parseInt(item.startNum)"
                        :inputType="'input'"
                        :size="'mini'"
                        :min="1"
                        :max="quesSumList.length"
                        :maxlength="4"
                        :content="$t('SetUp.StartNum')"
                        @valueChange="val => (item.startNum = val)"
                    ></PopoverNum>
                    <span class="text">{{$t('SetUp.ToTheEndQuestion')}}</span>
                    <PopoverNum
                        :value="parseInt(item.endNum)"
                        :inputType="'input'"
                        :size="'mini'"
                        :min="1"
                        :max="quesSumList.length"
                        :maxlength="4"
                        :content="$t('SetUp.EndNum')"
                        @valueChange="val => (item.endNum = val)"
                    ></PopoverNum>
                    <span class="text">{{$t('SetUp.Randomizing')}}</span>
                    <PopoverNum
                        :value="parseInt(item.sum)"
                        :inputType="'input'"
                        :size="'mini'"
                        :min="0"
                        :max="item.endNum - item.startNum + 1"
                        :maxlength="4"
                        :content="`${$t('SetUp.TheCurrentRangeOnlyHas')}${item.endNum - item.startNum + 1}${$t('SetUp.Questions')}`"
                        @valueChange="val => (item.sum = val)"
                    ></PopoverNum>
                    <span class="text">{{$t('SetUp.Question')}}</span>
                    <div class="icon_num">
                        <i class="icon iconfont iconjian" @click="removeQuesList(index)"></i>
                        <i class="icon iconfont iconjia" @click="addQuesList(index)"></i>
                    </div>
                </div>
            </div>
            <div class="quesList-box" v-if="randomType == 3">
                <el-button 
                    icon="el-icon-circle-plus-outline" 
                    size="small" 
                    v-if="pageList.length == 0" 
                    @click="addPageList()"
                >{{$t('SetUp.NewlyAdded')}}</el-button>
                <div class="item" v-for="(item, index) in pageList" :key="index">
                    <span class="text">{{$t('SetUp.FromStartPage')}}</span>
                    <PopoverNum
                        :value="parseInt(item.startNum)"
                        :inputType="'input'"
                        :size="'mini'"
                        :min="1"
                        :max="pageSumList.length"
                        :maxlength="4"
                        :content="$t('SetUp.pageStartNum')"
                        @valueChange="val => (item.startNum = val)"
                    ></PopoverNum>
                    <span class="text">{{$t('SetUp.ToEndPage')}}</span>
                    <PopoverNum
                        :value="parseInt(item.endNum)"
                        :inputType="'input'"
                        :size="'mini'"
                        :min="1"
                        :max="pageSumList.length"
                        :maxlength="4"
                        :content="$t('SetUp.PageEndNum')"
                        @valueChange="val => (item.endNum = val)"
                    ></PopoverNum>
                    <span class="text">{{$t('SetUp.Randomizing')}}</span>
                    <PopoverNum
                        :value="parseInt(item.sum)"
                        :inputType="'input'"
                        :size="'mini'"
                        :min="0"
                        :max="item.endNum - item.startNum + 1"
                        :maxlength="4"
                        :content="`${$t('SetUp.TheCurrentRangeOnlyHas')}${item.endNum - item.startNum + 1}${$t('SetUp.Pages')}`"
                        @valueChange="val => (item.sum = val)"
                    ></PopoverNum>
                    <span class="text">{{$t('SetUp.Pages')}}</span>
                    <div class="icon_num">
                        <i class="icon iconfont iconjian" @click="removePageList(index)"></i>
                        <i class="icon iconfont iconjia" @click="addPageList(index)"></i>
                    </div>
                </div>
            </div>
            <div class="quesList-box" v-if="randomType == 4">
                <div class="item" v-for="(item, index) in subsectionList" :key="index">
                    <el-checkbox v-model="item.isRandom">{{$t('SetUp.RemoveObstaclesFrom')}}<strong>{{$t('SetUp.Page')}}{{index + 1}}{{$t('SetUp.Pages')}}</strong>{{$t('SetUp.RandomFunction')}}</el-checkbox>
                    <el-checkbox v-if="item.isRandom" v-model="item.isShowOnlyPart">{{$t('SetUp.ShowOnlySomeTitlesOnThisPage')}}</el-checkbox>
                    <template v-if="item.isRandom && item.isShowOnlyPart">
                        <span class="text">{{$t('SetUp.NumberOfQuestions')}}：</span>
                        <PopoverNum
                            :value="parseInt(item.showSum)"
                            :inputType="'input'"
                            :size="'mini'"
                            :min="0"
                            :max="item.quesSum"
                            :maxlength="4"
                            :content="`${$t('SetUp.TheCurrentPageHas')}${item.quesSum}${$t('SetUp.Questions')}`"
                            @valueChange="val => (item.showSum = val)"
                        ></PopoverNum>
                    </template>
                </div>
            </div>
            
            <div class="tip-box">
                <strong>{{$t('SetUp.Tip')}}:</strong>
                {{$t('SetUp.CheckOn')}}
            </div>
        </div>
		<span slot="footer" class="dialog-footer">
            <el-button size="small" @click="cancel">{{$t('main.cancel2')}}</el-button>
            <el-button 
                size="small"
                type="primary" 
                @click="submit"
            >{{$t('main.ok2')}}</el-button>
		</span>
    </el-dialog>
</template>

<script>
import PopoverNum from "@/components/myComponents/popoverNum.vue"
export default {
	// 问卷设置 随机（试题/随机抽取试题）设置
    name: 'RandomSet',
    components:{
        PopoverNum
    },
    props: {
        paperjson: {
            type: String,
            default: ''
        },
        id: {
            type: String,
            default: ''
        },
        randomJson: {
            type: String,
            default: ''
        },
    },
    data() {
        return {
            randomSetShow: false,
            randomType: 1,
            input: '',
            // 试题随机条件列表
            quesList: [],
            // 分页随机条件列表
            pageList: [],
            // 分段列表
            subsectionList: []
        }
    },
    computed: {
        questionsList() {
            return JSON.parse(this.paperjson).questionsList
        },
        // 试题列表（排除分页与段落说明）
        quesSumList() {
            let arr = this.questionsList.filter(info => {
                return info.questionsTypeId != '25' && info.questionsTypeId != '26'
            })
            return arr
        },
        // 分页列表
        pageSumList() {
            let quesSumList = []
            let quesList = []
            let arr = this.questionsList.filter((info, index) => {
                if (info.questionsTypeId != '26' ) {
                    quesList.push(info)
                } else if (index != 0) {
                    quesSumList.push(quesList.length)
                    quesList = []
                }
                if (index == this.questionsList.length - 1) {
                    quesSumList.push(quesList.length)
                }
                return info.questionsTypeId == '26'
            })
            arr = arr.map((info, index) => {
                info.quesSum = quesSumList[index]
                return info
            })
            return arr
        }
    },
    watch:{
        randomType(newV, oldV) {
            console.log(newV)
            if (newV == 2) {
                if (this.quesSumList.length < 2) {
                    this.$alert(this.$t('SetUp.MoreThanTwoQuestions'), this.$t('SetUp.Tip'), {
                        confirmButtonText: this.$t('SetUp.GotIt'),
                        callback: action => {
                        }
                    });
                    this.randomType = oldV
                }
            } else if (newV == 3) {
                if (this.pageSumList.length < 2) {
                    this.$alert(this.$t('SetUp.OverTwoPages'), this.$t('SetUp.Tip'), {
                        confirmButtonText: this.$t('SetUp.GotIt'),
                        callback: action => {
                        }
                    });
                    this.randomType = oldV
                }
            } else if (newV == 4) {
                console.log(this.pageSumList)
                if (this.pageSumList.length > 0) {
                    this.pageSumList.forEach(info => {
                        let obj = {
                            isRandom: false, // 当前页是否随机
                            isShowOnlyPart: false, // 只显示部分试题
                            showSum: 0, // 只显示的部分试题数量
                            quesSum: info.quesSum, // 当前页的试题数量
                        }
                        this.subsectionList.push(obj)
                    })
                } else {
                    let obj = {
                        isRandom: false, // 当前页是否随机
                        isShowOnlyPart: false, // 只显示部分试题
                        showSum: 0, // 只显示的部分试题数量
                        quesSum: this.quesSumList.length
                    }
                    this.subsectionList.push(obj)
                }
            }
        }
    },
	created() {
	},
    methods: {
        randomTypeInput() {
            this.quesList = []
            this.pageList = []
            this.subsectionList = []
        },
        // 父级操作
        randomSetChange() {
            this.randomSetShow = true
            this.init()
        },
        // 初始化
        init() {
            if (this.$functions.isJSON(this.randomJson)) {
                let randomObj = JSON.parse(this.randomJson)
                this.randomType = randomObj.randomType
                this.quesList = randomObj.quesList
                this.pageList = randomObj.pageList
                this.subsectionList = randomObj.subsectionList
            }
        },
        cancel() {
            this.randomSetShow = false
            // 清空填空
        },
        submit() {
            // 确定 并验证
            let data = {
                randomType: this.randomType,
                quesList: this.quesList,
                pageList: this.pageList,
                subsectionList: this.subsectionList,
            }
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.modifyRandomJson}`,
				method: 'POST',
				data: {
					id: that.id,
					randomJson: JSON.stringify(data)
				},
				cb(res) {
					if (res.code == 0) {
						// console.log(res)
                        that.$emit('update')
					}
                    that.cancel()
				}
			};
			this.$util.request(params);
        },
        addQuesList(index) {
            let obj = {
                startNum: 1,
                endNum: this.quesSumList.length,
                sum: 0
            }

			if (index != 'undefined') {
				this.quesList.splice(index + 1, 0, obj);
			} else {
				this.quesList.push(obj);
			}
        },
        removeQuesList(index) {
            this.quesList.splice(index, 1)
        },
        addPageList(index) {
            let obj = {
                startNum: 1,
                endNum: this.pageSumList.length,
                sum: 0
            }

			if (index != 'undefined') {
				this.pageList.splice(index + 1, 0, obj);
			} else {
				this.pageList.push(obj);
			}
        },
        removePageList(index) {
            this.pageList.splice(index, 1)
        },
		
    }
}
</script>

<style lang="scss" scoped>
    .radio-group{
        margin-bottom: 16px;
    }
    /deep/.el-dialog{
        width: 1050px;
    }
    .el-dialog__body_div{
        padding: 10px 20px 20px !important;
    }
    .quesList-box {
        /deep/.el-input{
            width: 100px;
        }
        .text{
            display: inline-block;
            margin: 0 10px;
        }
        .item{
            height: 28px;
            display: flex;
            align-items: center;
        }
        .item+.item{
            margin-top: 10px;
        }
        .icon{
            cursor: pointer;
            font-size: 20px;
            color: #ccc;
            margin-left: 10px;
        }
    }
    .tip-box{
        margin-top: 20px;
    }
</style>